import { FormControlLayoutProps } from './FormControlLayout.js'
import { FormControlProps } from './types.js'

export const extractLayoutProps = <T extends FormControlProps>({
  name,
  label,
  secondaryLabel,
  tertiaryLabel,
  helperText,
  error,
  invalid,
  hidden,
  ...rest
}: T) => {
  const layoutProps: Omit<FormControlLayoutProps, 'children'> = {
    name,
    label,
    secondaryLabel,
    tertiaryLabel,
    helperText,
    error,
    invalid,
    hidden,
  }

  const inputProps = {
    id: name,
    name,
    invalid,
    ...rest,
  }

  return { layoutProps, inputProps }
}
